import SavingsBucket from './SavingsBucket'

export default SavingsBucket
